import React from 'react';
import { X } from 'lucide-react';

// Modal reutilizavel de visualizacao (somente leitura) dos dados cadastrados de um registro.
// sections: [{ title, columns?, fields: [{ label, value }] }] — campos com valor vazio sao ocultados.
function RecordViewModal({ open, onClose, title = 'Detalhes do registro', subtitle = 'Dados registrados — somente leitura.', sections = [] }) {
  if (!open) return null;

  // Considera vazio: null, undefined, string em branco ou o traço padrao '-'.
  const isEmpty = (value) => value === null || value === undefined || String(value).trim() === '' || String(value).trim() === '-';

  const gridClassByColumns = { 1: 'sm:grid-cols-1', 2: 'sm:grid-cols-2', 3: 'sm:grid-cols-3' };

  return (
    <div className="fixed inset-0 z-40 flex items-center justify-center px-4 py-4 sm:py-0">
      <button
        type="button"
        className="absolute inset-0 bg-slate-900/40"
        onClick={onClose}
        aria-label="Fechar"
      />
      <div className="relative z-10 max-h-[90vh] w-full max-w-3xl overflow-y-auto rounded-2xl bg-white p-4 shadow-xl sm:p-6">
        <div className="flex items-start justify-between">
          <div>
            <p className="text-xs uppercase tracking-[0.3em] text-slate-400">Visualização</p>
            <h3 className="text-xl font-semibold text-slate-900">{title}</h3>
            <p className="mt-1 text-sm text-slate-500">{subtitle}</p>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="inline-flex h-9 w-9 items-center justify-center rounded-md text-slate-400 transition hover:bg-slate-100 hover:text-slate-700"
            aria-label="Fechar"
          >
            <X className="h-4 w-4" />
          </button>
        </div>

        <div className="mt-6 space-y-6">
          {sections.map((section) => {
            const fields = (section.fields || []).filter((field) => !isEmpty(field.value));
            if (fields.length === 0) return null;
            const columns = gridClassByColumns[section.columns] || gridClassByColumns[2];

            return (
              <div key={section.title}>
                <p className="mb-3 text-xs font-semibold uppercase tracking-[0.2em] text-slate-400">{section.title}</p>
                <div className={`grid gap-3 ${columns}`}>
                  {fields.map((field) => (
                    <div key={field.label} className="rounded-lg border border-slate-100 bg-slate-50 px-3 py-2.5">
                      <p className="text-[11px] uppercase tracking-[0.15em] text-slate-400">{field.label}</p>
                      <p className="mt-0.5 text-sm font-medium text-slate-800">{field.value}</p>
                    </div>
                  ))}
                </div>
              </div>
            );
          })}
        </div>

        <div className="mt-6 flex justify-end">
          <button
            type="button"
            onClick={onClose}
            className="rounded-md border border-slate-200 px-4 py-2 text-sm font-medium text-slate-600 transition hover:border-blue-200 hover:text-blue-600"
          >
            Fechar
          </button>
        </div>
      </div>
    </div>
  );
}

export default RecordViewModal;
